// extracted by mini-css-extract-plugin
module.exports = {"root":"Wjw8jmux","rowSkeletonWrapper":"IrcJKARB"};